import {
    patchProductEditApiUrl,
    productDetailedApiUrl,
    productListingApiUrl,
    productStatsApiUrl,
    shopProductCreateApiUrl,
} from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getProducts = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(productListingApiUrl + `${query || ""}`, config);

    return response;
};

export const getProductStats = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(productStatsApiUrl, config);

    return response;
};

export const getProductDetails = async (slug, lang) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const url = lang ? `${productDetailedApiUrl}${slug}/?lang=${lang}` : `${productDetailedApiUrl}${slug}/`;
    const response = await axios.get(url, config);
    return response;
};

export const patchProductDetails = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(patchProductEditApiUrl + id + "/", data, config);
    return response;
};

export const patchProductDetailsFormData = async ({ id, data }) => {
    const config = {
        headers: {
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(patchProductEditApiUrl + id + "/", data, config);
    return response;
};

/** POST JSON body to `dashboard/shop-product-create/`. */
export const postProduct = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    return axios.post(shopProductCreateApiUrl, data, config);
};